import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import Header from './components/Header';
import Hero from './components/Hero';
import Advantages from './components/Advantages';
import QuiSommesNous from './components/QuiSommesNous';
import TroisExpertises from './components/TroisExpertises';
import PackMaintenanceSection from './components/PackMaintenanceSection';
import Products from './components/Products';
import Gallery from './components/Gallery';
import FormsSection from './components/FormsSection';
import Footer from './components/Footer';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import GalleryManager from './pages/GalleryManager';
import MentionsLegales from './pages/MentionsLegales';
import PolitiqueConfidentialite from './pages/PolitiqueConfidentialite';
import SansMaconnerie from './pages/SansMaconnerie';
import ConformiteCarsat from './pages/ConformiteCarsat';
import MaintenanceSAV from './pages/MaintenanceSAV';
import MaintenanceQuai from './pages/MaintenanceQuai';
import PiecesDetacheesQuai from './pages/PiecesDetacheesQuai';
import ContratsEntretienQuai from './pages/ContratsEntretienQuai';
import MaintenanceIndustrielle from './pages/MaintenanceIndustrielle';
import SoudageReparationMetallique from './pages/SoudageReparationMetallique';
import QuoteConfirmation from './pages/QuoteConfirmation';
import ContactConfirmation from './pages/ContactConfirmation';
import RealisationsListPage from './pages/RealisationsListPage';
import RealisationDetailPage from './pages/RealisationDetailPage';
import RealisationsAdminPage from './pages/RealisationsAdminPage';
import RealisationFormPage from './pages/RealisationFormPage';
import SEO from './components/SEO';
import { Toaster } from './components/ui/sonner';
import './App.css';

const HomePage = () => {
  return (
    <>
      <SEO />
      <Header />
      <main>
        <Hero />
        <QuiSommesNous />
        <TroisExpertises />
        <PackMaintenanceSection />
        <Advantages />
        <Products />
        <Gallery />
        <FormsSection />
      </main>
      <Footer />
    </>
  );
};

function App() {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
      language="fr"
    >
      <HelmetProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="/admin/gallery" element={<GalleryManager />} />
              <Route path="/admin/realisations" element={<RealisationsAdminPage />} />
              <Route path="/admin/realisations/create" element={<RealisationFormPage />} />
              <Route path="/admin/realisations/edit/:id" element={<RealisationFormPage />} />
              <Route path="/mentions-legales" element={<MentionsLegales />} />
              <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
              <Route path="/installation-sans-maconnerie" element={<SansMaconnerie />} />
              <Route path="/conformite-carsat" element={<ConformiteCarsat />} />
              <Route path="/maintenance-sav" element={<MaintenanceSAV />} />
              <Route path="/maintenance-quai" element={<MaintenanceQuai />} />
              <Route path="/pieces-detachees-quai" element={<PiecesDetacheesQuai />} />
              <Route path="/contrats-entretien-quai" element={<ContratsEntretienQuai />} />
              <Route path="/maintenance-industrielle" element={<MaintenanceIndustrielle />} />
              <Route path="/soudage-reparation-metallique" element={<SoudageReparationMetallique />} />
              <Route path="/confirmation-devis" element={<QuoteConfirmation />} />
              <Route path="/confirmation-contact" element={<ContactConfirmation />} />
              <Route path="/realisations" element={<RealisationsListPage />} />
              <Route path="/realisations/:slug" element={<RealisationDetailPage />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </div>
      </HelmetProvider>
    </GoogleReCaptchaProvider>
  );
}

export default App;
